import { ExtensionURLs } from "../constants/stores.constant";

declare const InstallTrigger: Object | undefined;

// Edge also has a .chrome property, but we don't support Edge!
export const isChrome = !!(window as any).chrome;
export const isFirefox = typeof InstallTrigger !== "undefined";
export const isBrave = (navigator as any).brave?.isBrave();
export const isSafari = !!(window as any).safari;

const getBrowserName = (): string | null => {
  if (isChrome) return "Chrome";
  if (isFirefox) return "Firefox";
  if (isBrave) return "Brave";
  if (isSafari) return "Safari";
  return null;
};

const getExtensionURLForBrowser = (): string | null => {
  if (isChrome) {
    return ExtensionURLs.chrome;
  }

  if (isFirefox) {
    return ExtensionURLs.firefox;
  }

  if (isBrave) {
    return ExtensionURLs.brave;
  }

  if (isSafari) {
    return ExtensionURLs.safari;
  }

  return null;
};

export const browserName = getBrowserName();
export const extensionURLForBrowser = getExtensionURLForBrowser();

export const getRandomIntInRange = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
